<template>
	<el-form ref="form" :model="searchForm" label-width="80px" size="medium">
	  <div class="el-form-item">
	    <el-input placeholder="请输入内容" size="medium" v-model="searchForm.title1" class="input-with-select">
	      <el-select v-model="searchForm.select" slot="prepend" placeholder="请选择">
	        <el-option
	          v-for="item in options"
	          :key="item.value"
	          :label="item.label"
	          :value="item.value">
	        </el-option>
	      </el-select>
	    </el-input>
	  </div>
	  <div class="el-form-item">
	    <el-input placeholder="请输入内容" size="medium" v-model="searchForm.title1" class="input-with-select">
	      <el-select v-model="searchForm.select" class="first-select" slot="prepend" placeholder="请选择">
	        <el-option
	          v-for="item in options"
	          :key="item.value"
	          :label="item.label"
	          :value="item.value">
	        </el-option>
	      </el-select>
	      <el-select v-model="searchForm.select" class="second-select" slot="prepend" placeholder="请选择">
	        <el-option
	          v-for="item in options"
	          :key="item.value"
	          :label="item.label"
	          :value="item.value">
	        </el-option>
	      </el-select>
	    </el-input>
	  </div>
	  <div class="el-form-item">
	    <el-input placeholder="请输入内容" size="medium" v-model="searchForm.title1" class="input-with-select">
	      <el-select v-model="searchForm.select" class="first-select" slot="prepend" placeholder="请选择">
	        <el-option
	          v-for="item in options"
	          :key="item.value"
	          :label="item.label"
	          :value="item.value">
	        </el-option>
	      </el-select>
	      <el-select v-model="searchForm.select" class="second-select" slot="prepend" placeholder="请选择">
	        <el-option
	          v-for="item in options"
	          :key="item.value"
	          :label="item.label"
	          :value="item.value">
	        </el-option>
	      </el-select>
	      <el-button slot="append" icon="el-icon-plus"></el-button>
	    </el-input>
	  </div>
	  <el-row>
	    <el-col :span="18">
	      <el-form-item label="发表时间">
	        <el-date-picker
	          v-model="searchForm.time"
	          type="daterange"
	          range-separator="至"
	          start-placeholder="开始日期"
	          end-placeholder="结束日期">
	        </el-date-picker>
	      </el-form-item>
	    </el-col>
	    <el-col :span="6">
	      <el-button type="primary" size="medium" plain icon="el-icon-search">检索</el-button>
	      <el-button plain size="medium" icon="el-icon-refresh-left">重置</el-button>
	    </el-col>
	  </el-row>
	</el-form>
</template>

<script>
	export default {
	    name: "search",
	    data(){
	        return{
	            options: [{
	                    value: '0',
	                    label: '标题'
	                },
	                {
	                    value: '1',
	                    label: '第一作者'
	                }],
	            searchForm:{
	                select:"标题",
	                title1:"",
	                title2:"",
	                title3:"",
	                time:""
	            }
	        }
	    },
	    methods:{
	
	    },
	    mounted() {
	
	    }
	
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/search.vue